// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./BreadcrumbTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Breadcrumb-module__Container__cYNIT {
    width: 100%;
    min-width: 0;
}
/* Sized like a link text line so the layout does not jump once the entries arrive */
.Breadcrumb-module__LoadingContainer__lSYpl {
    /* stylelint-disable-next-line property-disallowed-list -- DS component */
    line-height: var(--ds-line-height-big);
    white-space: nowrap;
}

.Breadcrumb-module__LoadingIcon__QOt2Q {
    vertical-align: middle;
}

.Breadcrumb-module__LoadingBar__rDzmy {
    display: inline-block;
    width: var(--ds-64x);
    height: var(--ds-2x);
    margin-left: var(--ds-s);
    vertical-align: middle;
    background-color: var(--ds-breadcrumb-loading-bar-background-color);
    border-radius: var(--ds-border-radius-xs);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Breadcrumb-module__Container__cYNIT`,
	"LoadingContainer": `Breadcrumb-module__LoadingContainer__lSYpl`,
	"LoadingIcon": `Breadcrumb-module__LoadingIcon__QOt2Q`,
	"LoadingBar": `Breadcrumb-module__LoadingBar__rDzmy`
};
export default ___CSS_LOADER_EXPORT___;
